import axios from './Api' // <-- AJOUT : On importe l'API qui est dans le même dossier
const Compressor = require('compressorjs')

const compressImage = async (blobFile) => {
  return new Promise((resolve) => {
    if (blobFile?.type?.startsWith('image')) {
      new Compressor(blobFile, {
        quality: 0.6,
        success: (result) => {
          resolve(result)
        },
      })
    } else {
      resolve(blobFile)
    }
  })
}

const compressImages = async (medias) => {
  const compressedMedias = await Promise.all(
    medias.map((m) => compressImage(m.blobFile)),
  )
  return compressedMedias
}

// <-- AJOUT : Notre Helper centralisé pour les URL d'images
const getMediaUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;

  const cleanPath = path.startsWith('/') ? path : `/${path}`;

  if (axios && axios.defaults && axios.defaults.baseURL) {
    const baseUrl = axios.defaults.baseURL.replace(/\/api\/?$/, '');
    return `${baseUrl}${cleanPath}`;
  }

  return cleanPath;
};

// <-- MODIFICATION : On ajoute getMediaUrl à l'export final
export { compressImage, compressImages, getMediaUrl }